import Text from '@creator/ui/components/Text/Text';
import { cn } from '@creator/ui/utils/ui';
import PostByline from '@src/components/Post/PostByline';
import { ensureTokenUrl } from '@src/model/config/helpers';
import { ensurePostUrl } from '@src/model/upvote/helpers';
import { usePost } from '@src/store/posts/hooks/usePost';
import { type FC, useMemo } from 'react';
import { Link } from 'react-router';

export interface PostTitleAndBylineProps {
    className?: string;
    postId: string;
    tokenName: string;
}

export const PostTitleAndByline: FC<PostTitleAndBylineProps> = props => {
    const { postId, tokenName, className } = props;
    const post = usePost(postId);
    const postUrl = useMemo(() => `/${ensureTokenUrl(tokenName)}/${ensurePostUrl(postId, true)}`, [tokenName, postId]);

    function renderTitle() {
        return (
            <Text data-ssr="post-title" enableMultiline={true} as="h1" className="font-bold leading-tight lg:text-xl line-clamp-2">
                <Link to={postUrl} data-ssr="post-title">
                    {post?.title}
                </Link>
            </Text>
        );
    }

    return (
        <div className={cn('space-y-1', className)}>
            {renderTitle()}
            <PostByline className="h-5" tokenName={tokenName} postId={postId} />
        </div>
    );
};
